import { getOptimizelyCohorts, getOptimizelyEndUserId, getOptimizelySegments } from '../../optimizelyHelpers';

class Segment {
  track(data) {
    if (!imkt || !imkt.utils) {
      return;
    }

    const { action, attributes, category, label } = data;
    const { value, ...additionalAttributes } = (attributes || {});

    var eventProperties = {
      category,
      label,
      value,
      eventAction: action,
      urlParams: imkt.utils.url.getUrlParams() || {},
      optimizelyCohorts: getOptimizelyCohorts(),
      optimizelySegments: getOptimizelySegments(),
      optimizelyEndUserId: getOptimizelyEndUserId(),
      ...additionalAttributes
    };
    imkt.utils.tracking.trackEvent(action, eventProperties);
  }
}

export { Segment };

export default new Segment();
